import { Component, Input } from '@angular/core';

@Component({
  selector: 'time-tracking-button',
  templateUrl: './time-tracking-button.component.html',
  styleUrls: ['./time-tracking-button.component.scss'],
})
export class TimeTrackingButtonComponent {
  @Input()
  ec: any;
  @Input()
  c: any;
  @Input()
  ss: any;

  private _s: any;
  public get s(): any {
    return this._s;
  }
  @Input()
  public set s(v: any) {
    // console.log(v);

    if (this.c && this.c?.arr[0]?.taskId === v) this.status = 'start';
    if (this.c && !v) this.status = 'stop';
    if (this.ec && v) this.status = 'start';
    if (this.ec && !v) this.status = 'stop';
    this._s = v;
  }

  constructor() {}

  private _status: string = 'stop';
  public get status(): string {
    return this._status;
  }
  public set status(v: string) {
    this._status = v;
  }

  protected loading: boolean = false;

  async handleChange(e: any) {
    if (this.c) {
      await this.ss(
        { id: this.c?.arr[0]?.taskId, status: e },
        (loading: boolean) => {
          // console.log(loading);

          this.loading = loading;
        }
      );
      this.status = e;
    }
    if (this.ec) {
      if (e === 'stop') {
        this.ss({ id: this.s, status: e }, (loading: boolean) => {
          // console.log(loading);

          this.loading = loading;
        });
        this.status = e;
        this.status = e;
      } else {
        const wait = await this.ss(
          { id: null, status: e },
          (loading: boolean) => {
            // console.log(loading);
            this.loading = loading;
          }
        );
        if (wait) {
          this.status = e;
        }
      }
    }
  }
}
